/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ImportService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Import product data from an Excel file
     * @returns any Data imported successfully
     * @throws ApiError
     */
    public postImportProduct({
        formData,
        businessAreaId,
    }: {
        formData: {
            file?: Blob;
        },
        businessAreaId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/import/product',
            query: {
                'businessAreaId': businessAreaId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Import product data from an Excel file
     * @returns any Data imported successfully
     * @throws ApiError
     */
    public postImportProductStock({
        formData,
        storeId,
    }: {
        formData: {
            file?: Blob;
        },
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/import/product/stock',
            query: {
                'storeId': storeId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

}
